<template>
    <div>
        <!-- 타이틀 + 서치박스 -->

        <div class="row" v-show="page.search.display">
            <div class="col-md-12">
                <search-box
                    ref="searchBox"
                    :searchOpt="page.search"
                    :isSearchable="isSearchable"
                    @search="onSearch"
                    @download-csv="onDownloadCsv"
                ></search-box>
            </div>
        </div>

        <div class="row" v-xe-pm.E v-show="$store.getters.showErrorPoint && errorPoints.length">
            <div class="col-md-12">존재하지 않는 관제점</div>
            <div class="col-md-12">{{ errorPoints }}</div>
        </div>

        <!-- <div>
      <button type="submit" @click="onRefresh" >갱신 버튼</button>
    </div> -->

        <!-- 드롭존:상단 -->
        <div class="row m-t-40" :class="{ hide: !isEditMode }">
            <div class="col-md-12">
                <drop class="xe-drop-me" @drop="onLayoutDrop(...arguments)">
                    <h4 class="text-center">{{ $t("위젯을 여기에 드롭해 주세요.") }}</h4>
                </drop>
            </div>
        </div>

        <!-- edit 모드일때의 context 메뉴 -->
        <vue-context ref="ctxMenu">
            <template slot-scope="child" v-if="child.data">
                <li v-if="child.data.type !== 'xeForecast'">
                    <a href="javascript:;" @click.prevent="onSettingWidget(child.data)">
                        <i class="fa fa-edit"></i> {{ $t("수정") }}</a
                    >
                </li>
                <li>
                    <a href="javascript:;" @click.prevent="onDeleteWidget(child.data)">
                        <i class="fa fa-trash-alt"></i> {{ $t("삭제") }}</a
                    >
                </li>
            </template>
        </vue-context>

        <!-- 위젯 -->
        <div class="row" v-if="isShow">
            <div class="col-12" ref="screen">
                <!-- 편집모드 -->
                <template v-if="isEditMode">
                    <grid-layout
                            ref="editGridLayout"
                            class="gridlayout"
                            :class="{
                                'gridlayout--control': isControlDashboardPage,
                                'gridlayout--control-mobile': controlLayoutMode === 'mobile',
                                'gridlayout--overview-scale': overviewLayoutMode === 'tablet-landscape',
                                'gridlayout--overview-portrait': overviewLayoutMode === 'tablet-portrait',
                                'gridlayout--overview-mobile': overviewLayoutMode === 'mobile',
                            }"
                            :layout.sync="page.widgets"
                            :col-num="gridColNum"
                            :row-height="gridRowHeight"
                            :margin="gridMargin"
                            :is-draggable="true"
                            :is-resizable="true"
                            :responsive="gridResponsive"
                            :breakpoints="gridBreakpoints"
                            :cols="gridCols"
                            :vertical-compact="gridVerticalCompact"
                            :restore-on-drag="true"
                            :use-css-transforms="true"
                        >
                            <grid-item
                                v-for="widget in page.widgets"
                                :key="widget.id"
                                :class="{ 'grid-item--new': widget._justAdded }"
                                :x="widget.x"
                                :y="widget.y"
                                :w="widget.w"
                                :h="widget.h"
                                :i="widget.i"
                                :minH="widget.minH"
                                :minW="widget.minW"
                                :maxH="widget.maxH"
                                :maxW="widget.maxW"
                                @moved="onWidgetDragMoved"
                            >
                            <!-- <dnd-grid-container :layout.sync="page.widgets" :bubbleUp="false" :cellSize="cellSize" :margin="page.cellSize.margin || 0">  
            <dnd-grid-box :boxId="widget.id" v-for="widget in (page.widgets)" :key="widget.id" > -->
                            <div @contextmenu.prevent="openContextMenu($event, widget)" class="heightMAX">
                                <xe-chart-donut
                                    v-if="widget.type == 'xeChartDonut'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-discomfort-index
                                    v-if="widget.type == 'xeDiscomfortIndex'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-indoor-air-quality
                                    v-if="widget.type == 'xeIndoorAirQuality'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-chart-gauge
                                    v-if="widget.type == 'xeChartGauge'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-line
                                    v-if="widget.type == 'xeChartLine'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-pie
                                    v-if="widget.type == 'xeChartPie'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-radar
                                    v-if="widget.type == 'xeChartRadar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-scatter
                                    v-if="widget.type == 'xeChartScatter'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-horizontal-bar
                                    v-if="widget.type == 'xeChartHorizontalBar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-grid-table
                                    v-if="widget.type == 'xeGridTable'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-html
                                    v-if="widget.type == 'xeHtml'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-pivot-table
                                    v-if="widget.type == 'xePivotTable'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-energy-card
                                    v-if="widget.type == 'xeEnergyCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-simple-card
                                    v-if="widget.type == 'xeSimpleCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-goal-card
                                    v-if="widget.type == 'xeGoalCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-rank-card
                                    v-if="widget.type == 'xeRankCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-image
                                    v-if="widget.type == 'xeImage'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-cctv
                                    v-if="widget.type == 'xeCctv'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-realtime
                                    v-if="widget.type == 'xeRealtime'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-alarm-history
                                    v-if="widget.type == 'xeAlarmHistory'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :cellSize="cellSize"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-todo-widget
                                    v-if="widget.type == 'xeTodo'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :cellSize="cellSize"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-weather
                                    v-if="widget.type == 'xeWeather'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :cellSize="cellSize"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                    :showGrid="false"
                                />

                                <!-- new Widget -->
                                <xe-goal-usage-chart
                                    v-if="widget.type == 'xeGoalUsageChart'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                    @on-fetch-chart-data="getGoalUsageChartData"
                                />

                                <xe-usage-chart
                                    v-if="widget.type == 'xeUsageChart'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :cardHeight="widget.h"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-peek-card
                                    v-if="widget.type == 'xePeekCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :width="widget.w"
                                    :height="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-line
                                    v-if="widget.type == 'xeLine'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-area
                                    v-if="widget.type == 'xeArea'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-pie
                                    v-if="widget.type == 'xePie'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-doughnut
                                    v-if="widget.type == 'xeDoughnut'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-compare-chart
                                    v-if="widget.type == 'xeCompareChart'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-bar
                                    v-if="widget.type == 'xeBar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-horizontal-bar
                                    v-if="widget.type == 'xeHorizontalBar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-biz-info
                                    v-if="widget.type == 'xeBizInfo'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate
                                    v-if="widget.type == 'xeSelfRate'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate-new
                                    v-if="widget.type == 'xeSelfRateNew'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate-toc
                                    v-if="widget.type == 'xeSelfRateToc'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-indoor-env-info
                                    v-if="widget.type == 'xeIndoorEnvInfo'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-forecast
                                    v-if="widget.type == 'xeForecast'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-progress-card
                                    v-if="widget.type == 'xeProgressCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-compare-card
                                    v-if="widget.type == 'xeCompareCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-cost-card
                                    v-if="widget.type == 'xeCostCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate-card
                                    v-if="widget.type == 'xeSelfRateCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-carbon-saving
                                    v-if="widget.type === 'xeCarbonSaving'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                ></xe-carbon-saving>

                                <xe-energy-efficiency
                                    v-if="widget.type == 'xeEnergyEfficiency'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @change-view="onChangeEnergyEfficiencyView"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-data-card
                                    v-if="widget.type == 'xeDataCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-equipment-control
                                    v-if="widget.type == 'xeEquipmentControl'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :width="widget.w"
                                    :height="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-equip-status-monitor
                                    v-if="widget.type == 'xeEquipStatusMonitor'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :width="widget.w"
                                    :height="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-blank-widget
                                    v-if="widget.type == 'xeBlankWidget'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-split-line
                                    v-if="widget.type == 'xeSplitLine'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-fems-overview
                                    v-if="widget.type == 'xeFemsOverview'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-history-range
                                    v-if="widget.type == 'xeHistoryRange'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                    @on-period-change="onRefresh"
                                />
                            </div>
                        </grid-item>
                    </grid-layout>
                    <!-- </dnd-grid-box>
          </dnd-grid-container> -->
                </template>
                <template v-else>
                    <!-- 일반모드 -->
                    <div>
                        <!-- style="position:absolute; "  v-for="widget in (page.widgets)" :key="widget.id"
            :style="[
              { top:  page.cellSize.h * widget.position.y + 'px' },
              { left: page.cellSize.w * widget.position.x + 'px'},
              { width: page.cellSize.w * widget.position.w + 'px'},
              { height:   page.cellSize.h * widget.position.h + 'px' }
            ]"  -->

                        <grid-layout
                            class="gridlayout"
                            :class="{
                            'gridlayout--control': isControlDashboardPage,
                            'gridlayout--control-mobile': controlLayoutMode === 'mobile',
                            'gridlayout--overview-scale': overviewLayoutMode === 'tablet-landscape',
                            'gridlayout--overview-portrait': overviewLayoutMode === 'tablet-portrait',
                            'gridlayout--overview-mobile': overviewLayoutMode === 'mobile',
                        }"
                            :layout.sync="viewGridLayout"
                            :col-num="gridColNum"
                            :row-height="gridRowHeight"
                            :margin="gridMargin"
                            :is-draggable="false"
                            :is-resizable="false"
                            :responsive="gridResponsive"
                            :breakpoints="gridBreakpoints"
                            :cols="gridCols"
                            :vertical-compact="gridVerticalCompact"
                            :use-css-transforms="true"
                        >
                            <grid-item
                                v-for="widget in viewGridLayout"
                                :key="widget.i"
                                :x="widget.x"
                                :y="widget.y"
                                :w="widget.w"
                                :h="widget.h"
                                :i="widget.i"
                                :minH="widget.minH"
                                :minW="widget.minW"
                                :maxH="widget.maxH"
                                :maxW="widget.maxW"
                                :class="{
                                    'grid-item': true,
                                    'grid-item--no-shadow': widget.type === 'xeSplitLine',
                                }"
                                :style="{
                                    borderRadius:
                                        widget.type == 'xeEquipmentControl' || widget.type == 'xeBlankWidget'
                                            ? '20px !important'
                                            : '',
                                }"
                            >
                                <xe-goal-usage-chart
                                    v-if="widget.type == 'xeGoalUsageChart'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                    @on-fetch-chart-data="getGoalUsageChartData"
                                />

                                <xe-chart-donut
                                    v-if="widget.type == 'xeChartDonut'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-gauge
                                    v-if="widget.type == 'xeChartGauge'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-line
                                    v-if="widget.type == 'xeChartLine'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-pie
                                    v-if="widget.type == 'xeChartPie'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-radar
                                    v-if="widget.type == 'xeChartRadar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-scatter
                                    v-if="widget.type == 'xeChartScatter'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-chart-horizontal-bar
                                    v-if="widget.type == 'xeChartHorizontalBar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-discomfort-index
                                    v-if="widget.type == 'xeDiscomfortIndex'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-indoor-air-quality
                                    v-if="widget.type == 'xeIndoorAirQuality'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-grid-table
                                    v-if="widget.type == 'xeGridTable'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-html
                                    v-if="widget.type == 'xeHtml'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-energy-efficiency
                                    v-if="widget.type == 'xeEnergyEfficiency'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @change-view="onChangeEnergyEfficiencyView"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-pivot-table
                                    v-if="widget.type == 'xePivotTable'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-energy-card
                                    v-if="widget.type == 'xeEnergyCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-simple-card
                                    v-if="widget.type == 'xeSimpleCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-goal-card
                                    v-if="widget.type == 'xeGoalCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-rank-card
                                    v-if="widget.type == 'xeRankCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-image
                                    v-if="widget.type == 'xeImage'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-cctv
                                    v-if="widget.type == 'xeCctv'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-realtime
                                    v-if="widget.type == 'xeRealtime'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-alarm-history
                                    v-if="widget.type == 'xeAlarmHistory'"
                                    :widget="widget"
                                    :cellSize="cellSize"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-todo-widget
                                    v-if="widget.type == 'xeTodo'"
                                    :widget="widget"
                                    :cellSize="cellSize"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-weather
                                    v-if="widget.type == 'xeWeather'"
                                    :widget="widget"
                                    :cellSize="cellSize"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                    :showGrid="false"
                                />

                                <xe-usage-chart
                                    v-if="widget.type == 'xeUsageChart'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :cardHeight="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-peek-card
                                    v-if="widget.type == 'xePeekCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :width="widget.w"
                                    :height="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-line
                                    v-if="widget.type == 'xeLine'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-area
                                    v-if="widget.type == 'xeArea'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-pie
                                    v-if="widget.type == 'xePie'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-doughnut
                                    v-if="widget.type == 'xeDoughnut'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-compare-chart
                                    v-if="widget.type == 'xeCompareChart'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-bar
                                    v-if="widget.type == 'xeBar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-horizontal-bar
                                    v-if="widget.type == 'xeHorizontalBar'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-biz-info
                                    v-if="widget.type == 'xeBizInfo'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate
                                    v-if="widget.type == 'xeSelfRate'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate-new
                                    v-if="widget.type == 'xeSelfRateNew'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate-toc
                                    v-if="widget.type == 'xeSelfRateToc'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-indoor-env-info
                                    v-if="widget.type == 'xeIndoorEnvInfo'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-forecast
                                    v-if="widget.type == 'xeForecast'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-progress-card
                                    v-if="widget.type == 'xeProgressCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-compare-card
                                    v-if="widget.type == 'xeCompareCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-cost-card
                                    v-if="widget.type == 'xeCostCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-self-rate-card
                                    v-if="widget.type == 'xeSelfRateCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />

                                <xe-carbon-saving
                                    v-if="widget.type === 'xeCarbonSaving'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                ></xe-carbon-saving>

                                <xe-data-card
                                    v-if="widget.type == 'xeDataCard'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-equipment-control
                                    v-if="widget.type == 'xeEquipmentControl'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :width="widget.w"
                                    :height="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-equip-status-monitor
                                    v-if="widget.type == 'xeEquipStatusMonitor'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :width="widget.w"
                                    :height="widget.h"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-blank-widget
                                    v-if="widget.type == 'xeBlankWidget'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-split-line
                                    v-if="widget.type == 'xeSplitLine'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-fems-overview
                                    v-if="widget.type == 'xeFemsOverview'"
                                    ref="xeWidgets"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                />
                                <xe-history-range
                                    v-if="widget.type == 'xeHistoryRange'"
                                    ref="xeWidgets"
                                    :widget="widget"
                                    :searchOpt="page.search"
                                    :searchBoxCond="searchBoxCond"
                                    :searchLogs="searchLogs"
                                    :cellSize="cellSize"
                                    :contextMenu="contextMenu"
                                    :cardHeight="widget.h"
                                    :cardWidth="widget.w"
                                    @on-handle-title-drop="handleTitleDrop(...arguments)"
                                    @on-change-widget="onChangeWidget"
                                    @on-remove-widget="onDeleteWidget(widget)"
                                    @on-period-change="onRefresh"
                                />
                            </grid-item>
                        </grid-layout>
                    </div>
                </template>
            </div>
        </div>

        <!-- 편집 실행 취소 -->
        <div v-if="isEditMode && canUndoLayout" class="layout-undo-bar">
            <button type="button" class="btn btn-sm btn-outline-primary" @click="undoLayoutChange">
                <i class="fa fa-undo m-r-5"></i>{{ $t("실행 취소") }} (Ctrl+Z)
            </button>
            <span class="layout-undo-hint">{{ $t("위젯 추가·이동·삭제를 되돌릴 수 있습니다.") }}</span>
        </div>

        <!-- 드롭존:하단 -->
        <div class="row m-t-40" :class="{ hide: !isEditMode }">
            <div class="col-md-12">
                <drop class="xe-drop-me" @drop="onLayoutDrop(...arguments)">
                    <h4 class="text-center">{{ $t("위젯을 여기에 드롭해 주세요.") }}</h4>
                </drop>
            </div>
        </div>

        <todo-docs />
    </div>
</template>

<docs>

</docs>

<style scoped>
.xe-todo-docs {
    position: relative;
    top: 0px;
    left: 0px;
    width: 600px;
    min-height: 200px;
    background-color: burlywood;
    z-index: 100;
}
</style>

<style scoped>
.grid-item {
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    border-radius: 5px !important;
}

.grid-item--no-shadow {
    box-shadow: none;
}

/* 편집모드 리사이즈 핸들이 위젯에 가려지는 케이스 방지
   (특히 글래스/오버레이 레이어가 있는 위젯에서 핸들 클릭이 막히는 문제) */
::v-deep .vue-grid-item {
    overflow: visible !important;
}

/* 컨트롤 대시보드: 좁은 셀에서 내용 넘침·가로 스크롤 방지 */
.gridlayout--control {
    overflow-x: hidden;
}

.gridlayout--control ::v-deep .vue-grid-item {
    overflow: hidden !important;
}

/* 모바일 웹 1열: 카드 간격·라운드 가독성 */
.gridlayout--control-mobile ::v-deep .vue-grid-item {
    border-radius: 16px !important;
}

/* 에너지 개요형 스케일: 24열 좌표 유지, 셀만 축소 */
.gridlayout--overview-scale {
    overflow-x: hidden;
}

.gridlayout--overview-scale ::v-deep .vue-grid-item {
    overflow: hidden !important;
    border-radius: 10px !important;
}

/* 가로 compact: 공통 타이틀·패딩 밀도 (위젯 내부 고정 px 완화) */
.gridlayout--overview-scale ::v-deep .kbet-widget-energy .title,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 .title,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .title {
    font-size: 12px !important;
    line-height: 28px !important;
    min-height: 28px !important;
    height: 28px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 {
    min-height: 0 !important;
    grid-template-rows: 28px auto 28px !important;
    -ms-grid-rows: 28px auto 28px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 {
    min-height: 0 !important;
    grid-template-rows: 28px auto 8px 28px !important;
    -ms-grid-rows: 28px auto 8px 28px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 .value-usage strong,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .value-usage strong {
    font-size: 16px !important;
    line-height: 1.2 !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 .value-usage span,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .value-usage span,
.gridlayout--overview-scale ::v-deep .xe-cost-card-container .value-usage span {
    margin-top: 0 !important;
    margin-left: 3px !important;
    font-size: 11px !important;
    vertical-align: baseline !important;
    line-height: 1.2 !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 .bg-icon,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .bg-icon {
    font-size: 48px !important;
}

.gridlayout--overview-scale ::v-deep .chartHeightMax {
    height: calc(100% - 28px) !important;
}

.gridlayout--overview-scale ::v-deep .chartHeightMax .p-5 {
    padding: 0.25rem !important;
}

.gridlayout--overview-scale ::v-deep .xePeekCard .peak-v1 strong,
.gridlayout--overview-scale ::v-deep .xePeekCard .peak-content strong {
    font-size: 14px !important;
}

.gridlayout--overview-scale ::v-deep .xePeekCard .today-peak {
    margin-left: 6px;
}

/* 타이틀 28px와 body 높이 계산 동기화 */
.gridlayout--overview-scale ::v-deep .monitoring_wrap,
.gridlayout--overview-scale ::v-deep .fems-overview-container,
.gridlayout--overview-scale ::v-deep .heightImportant {
    height: calc(100% - 28px) !important;
}

.gridlayout--overview-scale ::v-deep .xePeekCard .divider-line {
    height: 56px !important;
    max-height: 70% !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .weather-title,
.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .title {
    height: auto !important;
    min-height: 0 !important;
    line-height: 1.2 !important;
    font-size: 14px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .weather-title {
    height: 36px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .weather-title strong {
    line-height: 36px !important;
    font-size: 14px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .weather-area-v1 {
    margin-top: 6px !important;
    margin-bottom: 4px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .info-area {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .value-contrast {
    font-size: 10px !important;
    line-height: 1.2 !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 .value-contrast,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .value-contrast,
.gridlayout--overview-scale ::v-deep .xe-cost-card-container .value-contrast {
    padding-top: 2px !important;
    padding-bottom: 4px !important;
    margin: 0 !important;
    min-height: 0 !important;
    height: auto !important;
    line-height: 1.2 !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v1 .value-usage,
.gridlayout--overview-scale ::v-deep .kbet-widget-valueCard-v2 .value-usage {
    margin: 0 !important;
    padding: 0 4px !important;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .info-list,
.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .list-add li {
    font-size: 11px !important;
    line-height: 1.25 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.gridlayout--overview-scale ::v-deep .kbet-widget-infoCard .info-area {
    overflow: hidden;
}

/* SelfRate 전역 고정폭(472px) 해제 */
.gridlayout--overview-scale ::v-deep .usage-animation-area {
    min-width: 0 !important;
    min-height: 0 !important;
    height: calc(100% - 28px) !important;
    padding: 4px 6px 2px !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    overflow: hidden !important;
}

.gridlayout--overview-scale ::v-deep .usage-animation-area .area-align {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    flex: 1 1 auto !important;
    min-height: 0 !important;
}

.gridlayout--overview-scale ::v-deep .usage-animation-area .info_area {
    width: 55% !important;
    padding-left: 6px !important;
}

.gridlayout--overview-scale ::v-deep .usage-animation-area .img_area {
    width: 40% !important;
    max-width: 120px !important;
    overflow: hidden !important;
}

.gridlayout--overview-scale ::v-deep .usage-animation-area > .ex {
    position: static !important;
    bottom: auto !important;
    left: auto !important;
}

/* 에너지 개요형(태블릿 세로): 12열 템플릿 배치 */
.gridlayout--overview-portrait {
    overflow-x: hidden;
}

.gridlayout--overview-portrait ::v-deep .vue-grid-item {
    overflow: hidden !important;
    border-radius: 10px !important;
}

/* 에너지 개요형(모바일): 1열 스택 */
.gridlayout--overview-mobile {
    overflow-x: hidden;
}

.gridlayout--overview-mobile ::v-deep .vue-grid-item {
    overflow: hidden !important;
    border-radius: 16px !important;
}

::v-deep .vue-resizable-handle {
    z-index: 9999 !important;
    width: 18px;
    height: 18px;
    opacity: 0.9;
}

/* 드롭존 스타일 */
.xe-drop-me {
    min-height: 50px;
    margin-bottom: 20px;
    padding-top: 12px;
    border: dashed 1px;
    min-height: 50px;
    background-color: whitesmoke;
}

.layout-undo-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 12px 0 0;
    padding: 8px 12px;
    background: #f0f7ff;
    border: 1px solid #c5ddf8;
    border-radius: 6px;
}

.layout-undo-hint {
    font-size: 12px;
    color: #5a6a7a;
}

::v-deep .vue-grid-item.grid-item--new {
    box-shadow: 0 0 0 2px #4a90d9, 2px 2px 8px rgba(74, 144, 217, 0.35) !important;
}

/* 이하 어디서 사용중인지 모르겠음.. */
[draggable] {
    cursor: pointer;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}

li {
    color: black;
}

.dragging {
    opacity: 0.8;
    color: #6894d1;
}

.drag-over {
    outline: 1px solid red;
}

.drag-enter {
    color: #c93742;
}

/* 동작하지 않음.. */
.dropdown-menu {
    left: -52px !important;
}
</style>

<script>
import Vue from "vue";
import { Drop } from "vue-drag-drop";
import { Container, Box } from "@dattn/dnd-grid";
import "@dattn/dnd-grid/dist/dnd-grid.css";
import { VueContext } from "vue-context";
import axios from "axios";
//import PageOptions          from "../../config/PageOptions.vue";
import backEndApi from "@api/backEndApi.js";
import mobileBridge from "@src/utils/mobileBridge.js";
import SearchBox from "@src/views/widget/SearchBox.vue";
import xeCctv from "@src/views/widget/v1/xeCctv.vue";
import xeChartDonut from "@src/views/widget/v1/xeChartDonut.vue";
import xeChartGauge from "@src/views/widget/v1/xeChartGauge.vue";
import xeChartHorizontalBar from "@src/views/widget/v1/xeChartHorizontalBar.vue";
import xeChartLine from "@src/views/widget/v1/xeChartLine.vue";
import xeChartPie from "@src/views/widget/v1/xeChartPie.vue";
import xeChartRadar from "@src/views/widget/v1/xeChartRadar.vue";
import xeChartScatter from "@src/views/widget/v1/xeChartScatter.vue";
import xeEnergyCard from "@src/views/widget/v1/xeEnergyCard.vue";
import xeGoalCard from "@src/views/widget/v1/xeGoalCard.vue";
import xeGridTable from "@src/views/widget/v1/xeGridTable.vue";
import xeHtml from "@src/views/widget/v1/xeHtml.vue";
import xeImage from "@src/views/widget/v1/xeImage.vue";
import xePivotTable from "@src/views/widget/v1/xePivotTable.vue";
import xeRankCard from "@src/views/widget/v1/xeRankCard.vue";
import xeSimpleCard from "@src/views/widget/v1/xeSimpleCard.vue";

import xeAlarmHistory from "@src/views/widget/v1/xeAlarmHistoryWidget.vue";
import xeTodoWidget from "@src/views/widget/v1/xeTodoWidget.vue";
import xeWeather from "@src/views/widget/v1/xeWeatherWidget.vue";

// new Widget
import xeLine from "./v1/xeLine.vue";
import xeArea from "./v1/xeArea.vue";
import xePie from "./v1/xePie.vue";
import xeDoughnut from "./v1/xeDoughnut.vue";
import xePeekCard from "./v1/xePeekCard.vue";
import xeEquipmentControl from "./v1/xeEquipmentControl.vue";
import xeEquipStatusMonitor from "./v1/xeEquipStatusMonitor.vue";
import xeBlankWidget from "./v1/xeBlankWidget.vue";
import xeSplitLine from "./v1/xeSplitLine.vue";
import xeUsageChart from "./v1/xeUsageChart.vue";
import xeGoalUsageChart from "./v1/xeGoalUsageChart.vue";
import xeEnergyEfficiency from "./v1/xeEnergyEfficiency.vue";
import xeHistoryRange from "./v1/xeHistoryRange.vue";

import xeBar from "./v1/xeBar.vue";
import xeHorizontalBar from "./v1/xeHorizontalBar.vue";
import xeBizInfo from "./v1/xeBizInfo.vue";
import xeSelfRate from "./v1/xeSelfRate.vue";
import xeSelfRateNew from "./v1/xeSelfRateNew.vue";
import xeSelfRateToc from "./v1/xeSelfRateToc.vue";
import xeSelfRateCard from "./v1/xeSelfRateCard.vue";
import xeProgressCard from "./v1/xeCompareCard.vue";
import xeCompareCard from "./v1/xeIodCard.vue";
import xeDataCard from "./v1/xeDataCard.vue";
import xeCostCard from "./v1/xeCostCard.vue";
import xeCompareChart from "./v1/xeCompareChart.vue";
import xeIndoorEnvInfo from "./v1/xeIndoorEnvInfo.vue";
import xeForecast from "./v1/xeForecast.vue";
import xeDiscomfortIndex from "./v1/xeDiscomfortIndex.vue";
import xeIndoorAirQuality from "./v1/xeIndoorAirQuality.vue";

import xeFemsOverview from "./v1/xeFemsOverview.vue";
import xeCarbonSaving from "./v1/xeCarbonSaving.vue";

import { GridLayout, GridItem } from "vue-grid-layout";
import * as popupMessages from "@src/consts/popupMessageConsts";

/** 일반 대시보드: 기존 vue-grid-layout responsive 기본값 */
const DEFAULT_GRID_BREAKPOINTS = Object.freeze({
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0,
});
const DEFAULT_GRID_COLS = Object.freeze({
    lg: 24,
    md: 16,
    sm: 10,
    xs: 5,
    xxs: 2,
});

/** 컨트롤 대시보드 열 수 */
const CONTROL_DESKTOP_COLS = 24;
const CONTROL_TABLET_COLS = 12;
/** 모바일 웹 1열: col-num=4, 카드 w=4 */
const CONTROL_MOBILE_COLS = 4;

/**
 * 너비 분기 (컨테이너 기준, UA 아님)
 * - desktop: >= 1200
 * - tablet:  768 ~ 1199
 * - mobile:  < 768 (모바일 웹만, 네이티브 앱 제외)
 */
const CONTROL_DESKTOP_MIN_WIDTH = 1200;
const CONTROL_MOBILE_MAX_WIDTH = 768;
/** 에너지 개요형 스케일 rowHeight 기준 폭 (PC 설계 폭에 가까운 값) */
const OVERVIEW_SCALE_REF_WIDTH = 1400;
const OVERVIEW_SCALE_BASE_ROW_HEIGHT = 30;
/** 가로 스케일 시 너무 낮아지면 위젯 내부가 겹치므로 하한을 둔다 */
const OVERVIEW_SCALE_MIN_ROW_HEIGHT = 22;
/** 에너지 개요형: 세로에서 사용할 모드 기준 (컨테이너 width 기준) */
const OVERVIEW_TABLET_LANDSCAPE_MIN_WIDTH = 900; // 900 이상: tablet-landscape(현재 스케일 유지)
const OVERVIEW_TABLET_PORTRAIT_MIN_WIDTH = 600; // 600 이상: tablet-portrait(12열 템플릿 재배치)

// ---- 개요형(portrait/mobile 템플릿) 위젯 분류 ----
const OVERVIEW_BIZINFO_TYPE = "xeBizInfo";
const OVERVIEW_SELF_RATE_TYPES = Object.freeze(["xeSelfRate", "xeSelfRateNew", "xeSelfRateToc", "xeSelfRateCard"]);
const OVERVIEW_FEMS_TYPE = "xeFemsOverview";
const OVERVIEW_KPI_TYPES = Object.freeze([
    "xeCompareCard",
    "xeCostCard",
    "xeEnergyCard",
    "xeDataCard",
    "xeProgressCard",
    "xeSimpleCard",
    "xeGoalCard",
    "xeRankCard",
    "xeCarbonSaving",
]);
const OVERVIEW_PEEK_TYPES = Object.freeze(["xePeekCard"]);
const OVERVIEW_FULL_WIDTH_REST_TYPES = Object.freeze(["xeIndoorEnvInfo", "xeForecast", "xeWeather"]);

const CONTROL_DASHBOARD_WIDGET_TYPES = Object.freeze(["xeEquipmentControl", "xeBlankWidget", "xeSplitLine"]);

function compareControlWidgetsForPack(a, b) {
    const dy = (a.y || 0) - (b.y || 0);
    if (dy !== 0) return dy;
    // 같은 y에서는 구분선을 먼저 두어 섹션 경계를 명확히 한다.
    const aSplit = a.type === "xeSplitLine" ? 0 : 1;
    const bSplit = b.type === "xeSplitLine" ? 0 : 1;
    if (aSplit !== bSplit) return aSplit - bSplit;
    return (a.x || 0) - (b.x || 0);
}

function getControlLayoutBottom(items) {
    return items.reduce((maxY, item) => Math.max(maxY, (item.y || 0) + (item.h || 1)), 0);
}

/**
 * minY 이상에서만 first-fit 배치 (구분선 위 빈칸에 다음 섹션이 올라가지 않게).
 */
function packControlLayoutFirstFit(widgets, toCols, resolveWidth, minY = 0) {
    if (!Array.isArray(widgets) || widgets.length === 0) return [];

    const items = widgets.map((widget) => ({ ...widget })).sort(compareControlWidgetsForPack);
    const placed = [];

    for (const item of items) {
        if (item.type === "xeSplitLine") {
            // 섹션 패커에서 구분선은 별도 처리한다.
            continue;
        }

        const nextW = Math.min(resolveWidth(item), toCols);
        const nextH = item.h || 1;

        let placedItem = null;
        for (let y = minY; y < minY + 1000 && !placedItem; y++) {
            for (let x = 0; x <= toCols - nextW; x++) {
                const candidate = { x, y, w: nextW, h: nextH, i: item.i };
                if (!placed.some((other) => collidesControlGridItem(candidate, other))) {
                    placedItem = { ...item, x, y, w: nextW, h: nextH };
                    break;
                }
            }
        }

        placed.push(placedItem || { ...item, x: 0, y: minY, w: nextW, h: nextH });
    }

    return placed;
}

/**
 * xeSplitLine을 장벽으로 섹션을 나눈 뒤, 섹션별 패킹 → 구분선 전체 폭 → 다음 섹션.
 * PC에서처럼 「구분선 위 = 이전 구역 / 아래 = 다음 구역」을 태블릿·모바일에서도 유지한다.
 */
function packControlLayoutBySections(widgets, toCols, resolveWidth) {
    if (!Array.isArray(widgets) || widgets.length === 0) return [];

    const sorted = widgets.map((widget) => ({ ...widget })).sort(compareControlWidgetsForPack);
    const sections = [];
    let currentWidgets = [];

    for (const item of sorted) {
        if (item.type === "xeSplitLine") {
            sections.push({ widgets: currentWidgets, splitAfter: item });
            currentWidgets = [];
            continue;
        }
        currentWidgets.push(item);
    }
    sections.push({ widgets: currentWidgets, splitAfter: null });

    const result = [];
    let cursorY = 0;

    for (const section of sections) {
        const packed = packControlLayoutFirstFit(section.widgets, toCols, resolveWidth, cursorY);
        result.push(...packed);
        cursorY = Math.max(cursorY, getControlLayoutBottom(packed));

        if (section.splitAfter) {
            const splitH = Math.max(1, section.splitAfter.h || 1);
            result.push({
                ...section.splitAfter,
                x: 0,
                y: cursorY,
                w: toCols,
                h: splitH,
            });
            cursorY += splitH;
        }
    }

    return result;
}

/**
 * 24열 PC → 12열 태블릿 (행당 4칸, 구분선=섹션 장벽).
 * 원본 page.widgets 좌표는 변경하지 않는다(복사본만 생성).
 */
function scaleControlLayoutToTablet(widgets) {
    return packControlLayoutBySections(widgets, CONTROL_TABLET_COLS, (item) => {
        if (item.type === "xeBlankWidget") {
            return Math.max(1, Math.round(((item.w || 1) * CONTROL_TABLET_COLS) / CONTROL_DESKTOP_COLS));
        }
        return 3;
    });
}

/**
 * 모바일 웹 1열: 섹션별 세로 나열 + 구분선 전체 폭.
 */
function scaleControlLayoutToMobile(widgets) {
    return packControlLayoutBySections(widgets, CONTROL_MOBILE_COLS, (item) => {
        if (item.type === "xeBlankWidget" && (item.w || 1) <= 1) {
            return 1;
        }
        return CONTROL_MOBILE_COLS;
    });
}

function collidesControlGridItem(a, b) {
    if (a.i != null && b.i != null && a.i === b.i) return false;
    return !(a.x + a.w <= b.x || b.x + b.w <= a.x || a.y + a.h <= b.y || b.y + b.h <= a.y);
}

function compareOverviewWidgetsForPortrait(a, b) {
    const dy = (a.y || 0) - (b.y || 0);
    if (dy !== 0) return dy;
    return (a.x || 0) - (b.x || 0);
}

/**
 * 에너지 개요형: 모바일(1열 스택) 표시용 레이아웃(복사본).
 * 저장 JSON(page.widgets)은 변경하지 않는다.
 */
function buildOverviewMobileLayout(widgets, toCols = CONTROL_MOBILE_COLS) {
    if (!Array.isArray(widgets) || widgets.length === 0) return [];

    const items = widgets
        .filter((w) => w && w.type !== "xeBlankWidget")
        .slice()
        .sort(compareOverviewWidgetsForPortrait);

    const result = [];
    let cursorY = 0;

    for (const item of items) {
        const nextH = Math.max(1, item.h || 1);
        result.push({
            ...item,
            x: 0,
            y: cursorY,
            w: toCols,
            h: nextH,
        });
        cursorY += nextH;
    }

    return result;
}

/**
 * 에너지 개요형: 태블릿 세로(12열 템플릿) 표시용 레이아웃(복사본).
 * 저장 JSON(page.widgets)은 변경하지 않는다.
 *
 * 배치 의도:
 * - 상단: BizInfo
 * - 다음: KPI 카드(3개/줄, w=4)
 * - 다음: 실시간 자립률(Full)
 * - 다음: 종합운영(Full)
 * - 하단: 나머지 위젯은 (가능하면) 6|6로 짝지어 행 정렬
 */
function buildOverviewPortraitLayout(widgets, toCols = CONTROL_TABLET_COLS) {
    if (!Array.isArray(widgets) || widgets.length === 0) return [];

    const half = Math.max(1, Math.floor(toCols / 2)); // 6
    const kpiW = 4;

    const items = widgets
        .filter((w) => w && w.type !== "xeBlankWidget")
        .slice()
        .sort(compareOverviewWidgetsForPortrait);

    const placed = [];
    const usedIds = new Set();
    const widgetKey = (w) => (w.i != null ? w.i : w.id != null ? w.id : `${w.type}:${w.x}:${w.y}:${w.h}`);
    const cursorSet = (w) => {
        usedIds.add(widgetKey(w));
        return w;
    };

    let cursorY = 0;

    // 1) BizInfo(상단 고정)
    const bizList = items.filter((w) => w.type === OVERVIEW_BIZINFO_TYPE);
    for (const biz of bizList) {
        const nextH = Math.max(1, biz.h || 1);
        placed.push({ ...biz, x: 0, y: cursorY, w: toCols, h: nextH });
        cursorY += nextH;
        cursorSet(biz);
    }

    // 2) KPI 카드(3개/줄)
    const kpiList = items.filter((w) => OVERVIEW_KPI_TYPES.includes(w.type));
    let kpiQueue = kpiList.slice();
    while (kpiQueue.length) {
        const row = kpiQueue.splice(0, 3);
        const rowH = Math.max(...row.map((w) => Math.max(1, w.h || 1)));
        for (let idx = 0; idx < row.length; idx++) {
            const w = row[idx];
            placed.push({
                ...w,
                x: idx * kpiW,
                y: cursorY,
                w: kpiW,
                h: Math.max(1, w.h || 1),
            });
            cursorSet(w);
        }
        cursorY += rowH;
    }

    // 3) 실시간 자립률(Full)
    const selfRateList = items.filter((w) => OVERVIEW_SELF_RATE_TYPES.includes(w.type));
    for (const s of selfRateList) {
        const nextH = Math.max(1, s.h || 1);
        placed.push({ ...s, x: 0, y: cursorY, w: toCols, h: nextH });
        cursorY += nextH;
        cursorSet(s);
    }

    // 4) 종합운영(Fems)(Full)
    const femsList = items.filter((w) => w.type === OVERVIEW_FEMS_TYPE);
    for (const f of femsList) {
        const nextH = Math.max(1, f.h || 1);
        placed.push({ ...f, x: 0, y: cursorY, w: toCols, h: nextH });
        cursorY += nextH;
        cursorSet(f);
    }

    // 5) 나머지(가능하면 6|6 행 정렬)
    const rest = items.filter((w) => !usedIds.has(widgetKey(w)));
    const isFullWidthRest = (type) => OVERVIEW_FULL_WIDTH_REST_TYPES.includes(type);
    const isPairableRest = (type) =>
        !isFullWidthRest(type) && type !== OVERVIEW_BIZINFO_TYPE && !OVERVIEW_PEEK_TYPES.includes(type);

    const queue = rest.slice();
    while (queue.length) {
        const a = queue[0];

        // Peek는 2개가 있으면 6|6로
        if (a.type && OVERVIEW_PEEK_TYPES.includes(a.type)) {
            const b = queue[1] && queue[1].type === a.type ? queue[1] : null;
            if (b) {
                const ah = Math.max(1, a.h || 1);
                const bh = Math.max(1, b.h || 1);
                const rowH = Math.max(ah, bh);
                placed.push({ ...a, x: 0, y: cursorY, w: half, h: ah });
                placed.push({ ...b, x: half, y: cursorY, w: half, h: bh });
                cursorY += rowH;
                queue.shift();
                queue.shift();
            } else {
                const ah = Math.max(1, a.h || 1);
                placed.push({ ...a, x: 0, y: cursorY, w: toCols, h: ah });
                cursorY += ah;
                queue.shift();
            }
            continue;
        }

        // 예보/실내환경 같은 건 full로
        if (isFullWidthRest(a.type)) {
            const ah = Math.max(1, a.h || 1);
            placed.push({ ...a, x: 0, y: cursorY, w: toCols, h: ah });
            cursorY += ah;
            queue.shift();
            continue;
        }

        // 나머지는 다음 위젯과 짝지을 수 있으면 6|6
        const b = queue[1];
        if (b && isPairableRest(b.type)) {
            const ah = Math.max(1, a.h || 1);
            const bh = Math.max(1, b.h || 1);
            const rowH = Math.max(ah, bh);
            placed.push({ ...a, x: 0, y: cursorY, w: half, h: ah });
            placed.push({ ...b, x: half, y: cursorY, w: half, h: bh });
            cursorY += rowH;
            queue.shift();
            queue.shift();
        } else {
            const ah = Math.max(1, a.h || 1);
            placed.push({ ...a, x: 0, y: cursorY, w: toCols, h: ah });
            cursorY += ah;
            queue.shift();
        }
    }

    return placed;
}

export default global.module({
    components: {
        Drop,
        DndGridContainer: Container,
        DndGridBox: Box,
        VueContext,
        xeEnergyEfficiency,
        SearchBox,
        xeCctv,
        xeChartDonut,
        xeChartGauge,
        xeChartHorizontalBar,
        xeChartLine,
        xeChartPie,
        xeChartRadar,
        xeChartScatter,
        xeEnergyCard,
        xeGoalCard,
        xeGridTable,
        xeHtml,
        xeImage,
        xePivotTable,
        xeRankCard,
        xeSimpleCard,
        xeAlarmHistory,
        xeTodoWidget,
        xeWeather,
        GridLayout,
        GridItem,
        //new Widget
        xeLine,
        xeArea,
        xePie,
        xeDoughnut,
        xeBar,
        xeHorizontalBar,
        xeBizInfo,
        xeProgressCard,
        xeCompareCard,
        xeDataCard,
        xeCostCard,
        xePeekCard,
        xeEquipmentControl,
        xeEquipStatusMonitor,
        xeBlankWidget,
        xeSplitLine,
        xeUsageChart,
        xeGoalUsageChart,
        xeCompareChart,
        xeSelfRate,
        xeSelfRateNew,
        xeSelfRateToc,
        xeSelfRateCard,
        xeIndoorEnvInfo,
        xeForecast,
        xeCarbonSaving,
        xeDiscomfortIndex,
        xeIndoorAirQuality,
        xeFemsOverview,
        xeHistoryRange,
    },
    props: ["page"],
    data() {
        return {
            searchBoxDocs: SearchBox.__docs,

            cardIndex: 0,
            temp: {
                x: null,
                y: null,
                arrIndex: null,
            },
            card: [],

            isShow: false,

            colNum: 21,

            // searchBox가 조회시 생성한 조회설정값
            searchBoxCond: {
                // SearchBox 초기화 값과 동일해야 함..
                type: 4,
                period: {
                    sDt: new Date().format("yyyy-MM-dd"),
                    eDt: new Date().addDay(5).format("yyyy-MM-dd"),
                    points: {},
                },
                compare: {
                    sDt: new Date().format("yyyy-MM-dd"),
                    eDt: new Date().addDay(5).format("yyyy-MM-dd"),
                    points: {},
                },
            },
            // 조회결과
            searchLogs: [],
            // ctx 메뉴
            contextMenu: { widget: {}, isShowSetting: false },

            widgetConds: [],
            searchConds: [],

            isSearchable: true,
            searchCnt: 0,

            // axios 취소 관련 토큰 생성
            cancelToken: axios.CancelToken,
            cancelObj: {},

            screenWidth: -1,

            // 자동 화면 갱신 주기 조정
            onRefreshObj: null,
            refreshTerm: 1 * 60 * 1000,

            errorPoints: [],

            breakpoint: "lg",
            popupMessages,

            /** 컨트롤 대시보드 조회용: 컨테이너 너비 및 표시 전용 레이아웃 캐시 */
            gridContainerWidth: 0,
            controlDisplayLayout: null,
            overviewDisplayLayout: null,
            _gridResizeObserver: null,
            /** 개요형 가로 스케일 시 위젯 내부 밀도 (provide/inject, 반응형 객체) */
            overviewUi: {
                compact: false,
            },

            /** 편집 중 레이아웃 실행 취소 스택 */
            layoutUndoStack: [],
            _layoutUndoInProgress: false,
            _layoutDragSnapshotSaved: false,
            _layoutUndoKeydownBound: null,
            _gridDragSnapshotHandler: null,
            _gridDragEndHandler: null,
            _dragRestoreSnapshot: null,
        };
    },
    provide() {
        return {
            overviewUi: this.overviewUi,
        };
    },
    computed: {
        // 관제점 정보 맵(인메모리). store 를 직접 추적해, 늦게 채워져도 검색 시점에 최신값을 읽는다.
        liveAM() {
            return this.$store.getters.getLiveAM;
        },
        isEditMode() {
            return this.$store.getters.isEditMode;
        },
        cellSize() {
            // return  this.page.cellSize ? this.page.cellSize : { w: 10, h: 10 };
            // 10은 cell의 기본크기
            // 1654는 기본 전체화면일때의 크기

            // 모바일 환경에서 사이즈 고려 안됨
            if (this.isMobile) return { w: 10, h: 10 };

            let x = 10 * (this.boxRate / 100);
            return { w: x, h: x };
        },
        isFullScreen() {
            return this.pageOptions.pageEmpty;
        },
        boxRate() {
            let defaultScreenSize = 1654;

            return this.screenWidth.percentage(defaultScreenSize);
        },
        /** 설비 제어 위젯 비중이 높은 컨트롤 대시보드 페이지 여부 */
        isControlDashboardPage() {
            const widgets = this.page?.widgets;
            if (!Array.isArray(widgets) || widgets.length === 0) return false;

            const controlLikeCount = widgets.filter((widget) =>
                CONTROL_DASHBOARD_WIDGET_TYPES.includes(widget.type),
            ).length;

            return controlLikeCount / widgets.length >= 0.5;
        },
        /**
         * 에너지 개요형(건물정보 포함) — 컨트롤 대시보드가 아닌 잡지형 대시보드.
         * 태블릿에서는 좌표 재배치 대신 24열 고정 + 셀 스케일만 적용한다.
         */
        isOverviewDashboardPage() {
            if (this.isControlDashboardPage) return false;
            const widgets = this.page?.widgets;
            if (!Array.isArray(widgets) || widgets.length === 0) return false;
            return widgets.some((widget) => widget.type === "xeBizInfo");
        },
        /**
         * 에너지 개요형: 세로/가로 분리 모드.
         * - desktop: >= 1200
         * - tablet-landscape: 900 ~ 1199 (기존 스케일 유지)
         * - tablet-portrait: 600 ~ 899 (12열 템플릿 + 표시용 복사본)
         * - mobile: < 600 (1열 스택 + 표시용 복사본)
         */
        overviewLayoutMode() {
            if (!this.isOverviewDashboardPage) return "desktop";
            if (this.isEditMode) return "desktop";
            const width = this.gridContainerWidth || 0;
            if (width <= 0) return "desktop";

            const isMobileWeb = !mobileBridge.isNativeHemsApp();
            if (isMobileWeb && width < OVERVIEW_TABLET_PORTRAIT_MIN_WIDTH) return "mobile";
            if (width < OVERVIEW_TABLET_LANDSCAPE_MIN_WIDTH) return "tablet-portrait";
            if (width < CONTROL_DESKTOP_MIN_WIDTH) return "tablet-landscape";
            return "desktop";
        },
        /**
         * 개요형: tablet-landscape에서만 24열 좌표를 유지한 채 셀만 축소.
         */
        overviewScaleActive() {
            return this.overviewLayoutMode === "tablet-landscape";
        },
        /** 개요형 스케일 비율 (기준폭 OVERVIEW_SCALE_REF_WIDTH 대비) */
        overviewScaleRatio() {
            if (!this.overviewScaleActive) return 1;
            const width = this.gridContainerWidth;
            return Math.min(1, Math.max(0.35, width / OVERVIEW_SCALE_REF_WIDTH));
        },
        /**
         * 컨트롤 대시보드 표시 모드 (너비 기준).
         * mobile: 모바일 웹만 (네이티브 앱 제외) + width < 768 → 1열
         * tablet: 768 ~ 1199 → 12열
         * desktop: >= 1200 또는 편집 모드 → 24열 원본
         */
        controlLayoutMode() {
            if (!this.isControlDashboardPage || this.isEditMode || this.gridContainerWidth <= 0) {
                return "desktop";
            }
            const width = this.gridContainerWidth;
            const isMobileWeb = !mobileBridge.isNativeHemsApp();

            if (isMobileWeb && width < CONTROL_MOBILE_MAX_WIDTH) {
                return "mobile";
            }
            if (width < CONTROL_DESKTOP_MIN_WIDTH) {
                return "tablet";
            }
            return "desktop";
        },
        useControlDisplayLayout() {
            return this.controlLayoutMode === "tablet" || this.controlLayoutMode === "mobile";
        },
        useOverviewDisplayLayout() {
            if (!this.isOverviewDashboardPage) return false;
            if (this.isEditMode) return false;
            return this.overviewLayoutMode === "tablet-portrait" || this.overviewLayoutMode === "mobile";
        },
        /** 조회 모드 그리드에 바인딩할 레이아웃 (태블릿/모바일은 복사본 — 저장 JSON 미변경) */
        activeGridLayout() {
            if (this.useControlDisplayLayout && Array.isArray(this.controlDisplayLayout)) {
                return this.controlDisplayLayout;
            }
            if (this.useOverviewDisplayLayout && Array.isArray(this.overviewDisplayLayout)) {
                return this.overviewDisplayLayout;
            }
            return this.page?.widgets || [];
        },
        /**
         * layout.sync 용 get/set.
         * 태블릿/모바일 레이아웃일 때는 page.widgets(저장본)를 덮어쓰지 않는다.
         */
        viewGridLayout: {
            get() {
                return this.activeGridLayout;
            },
            set(nextLayout) {
                if (this.useControlDisplayLayout) {
                    this.controlDisplayLayout = nextLayout;
                    return;
                }
                if (this.useOverviewDisplayLayout) {
                    this.overviewDisplayLayout = nextLayout;
                    return;
                }
                this.page.widgets = nextLayout;
            },
        },
        /**
         * responsive off:
         * - 컨트롤: 자체 패킹
         * - 개요형 스케일: md/sm 열수 점프(24→16→10)로 PC 구도가 깨지는 것 방지
         */
        gridResponsive() {
            if (this.isControlDashboardPage) return false;
            if (this.isOverviewDashboardPage) return false;
            return true;
        },
        gridBreakpoints() {
            return DEFAULT_GRID_BREAKPOINTS;
        },
        gridCols() {
            return DEFAULT_GRID_COLS;
        },
        gridColNum() {
            if (this.isControlDashboardPage) {
                if (this.controlLayoutMode === "mobile") return CONTROL_MOBILE_COLS;
                if (this.controlLayoutMode === "tablet") return CONTROL_TABLET_COLS;
                return CONTROL_DESKTOP_COLS;
            }
            // 개요형(에너지 대시보드): 모드에 따라 col 수를 고정한다.
            if (this.isOverviewDashboardPage) {
                if (this.overviewLayoutMode === "tablet-portrait") return CONTROL_TABLET_COLS;
                if (this.overviewLayoutMode === "mobile") return CONTROL_MOBILE_COLS;
                // desktop / tablet-landscape
                return CONTROL_DESKTOP_COLS;
            }
            return this.colNum;
        },
        gridVerticalCompact() {
            // compact 로 y가 재계산되며 PC 잡지형 좌표가 흐트러지는 것 방지
            if (this.isControlDashboardPage) return false;
            if (this.isOverviewDashboardPage) return false;
            return true;
        },
        gridRowHeight() {
            if (this.isOverviewDashboardPage) {
                if (this.overviewLayoutMode === "mobile") return 44;
                if (this.overviewLayoutMode === "tablet-portrait") return OVERVIEW_SCALE_BASE_ROW_HEIGHT;
                if (this.overviewLayoutMode === "tablet-landscape") {
                    return Math.max(
                        OVERVIEW_SCALE_MIN_ROW_HEIGHT,
                        Math.round(OVERVIEW_SCALE_BASE_ROW_HEIGHT * this.overviewScaleRatio),
                    );
                }
                return OVERVIEW_SCALE_BASE_ROW_HEIGHT;
            }

            if (this.controlLayoutMode === "mobile") return 44;
            if (this.controlLayoutMode === "tablet") return 36;
            return OVERVIEW_SCALE_BASE_ROW_HEIGHT;
        },
        gridMargin() {
            if (this.isOverviewDashboardPage) {
                if (this.overviewLayoutMode === "mobile") return [10, 10];
                if (this.overviewLayoutMode === "tablet-portrait") return [8, 8];
                if (this.overviewLayoutMode === "tablet-landscape") {
                    // 좁은 셀에서 여백 비율이 과해지지 않게 축소
                    const m = this.overviewScaleRatio < 0.7 ? 4 : 6;
                    return [m, m];
                }
                return [10, 10]; // desktop
            }

            if (this.controlLayoutMode === "mobile") return [10, 10];
            if (this.isControlDashboardPage) return [8, 8];
            return [10, 10];
        },
        /** 좌표 변경만 추적 (실시간 상태 갱신으로 표시 레이아웃이 재생성되지 않게) */
        controlLayoutSignature() {
            return (this.page?.widgets || [])
                .map((widget) => `${widget.i}:${widget.x}:${widget.y}:${widget.w}:${widget.h}:${widget.type}`)
                .join("|");
        },
        canUndoLayout() {
            return this.layoutUndoStack.length > 0;
        },
    },
    watch: {
        "$store.getters.isEditMode": function (isEditMode) {
            // 수정모드에서는 위젯들이 dndgrid상에서 움직일 수 있도록 풀어준다.
            this.page.widgets.forEach((widget) => {
                widget.pinned = !this.isEditMode;
            });
            this.refreshControlDisplayLayout();
            this.refreshOverviewDisplayLayout();

            if (isEditMode) {
                this.bindLayoutUndoKeydown();
                this.$nextTick(() => this.bindGridDragSnapshot());
            } else {
                this.unbindLayoutUndoKeydown();
                this.unbindGridDragSnapshot();
                this.layoutUndoStack = [];
            }
        },
        isFullScreen: function () {
            this.initScreenSize();
        },
        controlLayoutSignature() {
            this.refreshControlDisplayLayout();
        },
        controlLayoutMode() {
            this.refreshControlDisplayLayout();
        },
        overviewLayoutMode: {
            immediate: true,
            handler(mode) {
                this.overviewUi.compact = mode === "tablet-landscape";
                this.refreshOverviewDisplayLayout();
            },
        },
    },

    mounted() {
        this.initSetting();
        this.$nextTick(() => {
            this.bindGridResizeObserver();
            this.refreshControlDisplayLayout();
            this.refreshOverviewDisplayLayout();
            this.overviewUi.compact = this.overviewLayoutMode === "tablet-landscape";
            if (this.isEditMode) {
                this.bindLayoutUndoKeydown();
                this.bindGridDragSnapshot();
            }
        });
    },
    // updated : function () { //DOM 어
    // this.$nextTick(function () {
    //   // Code that will run only after the
    //   // entire view has been re-rendered
    //   })
    // },

    beforeDestroy() {
        this.unbindGridResizeObserver();
        this.unbindLayoutUndoKeydown();
        this.unbindGridDragSnapshot();

        // 화면에 조회가 걸려있다면 cancel 시킨다.
        Object.keys(this.cancelObj).forEach((key) => {
            if (this.cancelObj[key] != null) this.cancelObj[key].cancel("page destroy");
        });

        Vue.nextTick(() => {
            this.isSearchable = true;
        });
    },
    methods: {
        bindGridResizeObserver() {
            const el = this.$refs.screen;
            if (!el || typeof ResizeObserver === "undefined") {
                this.gridContainerWidth = el?.clientWidth || window.innerWidth;
                this.refreshControlDisplayLayout();
                this.refreshOverviewDisplayLayout();
                return;
            }

            this.unbindGridResizeObserver();
            this._gridResizeObserver = new ResizeObserver((entries) => {
                const entry = entries[0];
                if (!entry) return;
                const width = entry.contentRect?.width || el.clientWidth;
                if (width && Math.abs(width - this.gridContainerWidth) >= 1) {
                    this.gridContainerWidth = width;
                    this.refreshControlDisplayLayout();
                    this.refreshOverviewDisplayLayout();
                }
            });
            this._gridResizeObserver.observe(el);
            this.gridContainerWidth = el.clientWidth || 0;
        },
        unbindGridResizeObserver() {
            if (this._gridResizeObserver) {
                this._gridResizeObserver.disconnect();
                this._gridResizeObserver = null;
            }
        },
        refreshControlDisplayLayout() {
            if (!this.isControlDashboardPage || this.isEditMode) {
                this.controlDisplayLayout = null;
                return;
            }

            const mode = this.controlLayoutMode;
            if (mode === "mobile") {
                this.controlDisplayLayout = scaleControlLayoutToMobile(this.page.widgets);
                return;
            }
            if (mode === "tablet") {
                this.controlDisplayLayout = scaleControlLayoutToTablet(this.page.widgets);
                return;
            }
            this.controlDisplayLayout = null;
        },
        refreshOverviewDisplayLayout() {
            if (!this.isOverviewDashboardPage || this.isEditMode) {
                this.overviewDisplayLayout = null;
                return;
            }

            // portrait/mobile 모드에서만 복사본 레이아웃을 만든다.
            if (this.overviewLayoutMode === "tablet-landscape" || this.overviewLayoutMode === "desktop") {
                this.overviewDisplayLayout = null;
                return;
            }

            if (!Array.isArray(this.page?.widgets) || this.page.widgets.length === 0) {
                this.overviewDisplayLayout = null;
                return;
            }

            if (this.overviewLayoutMode === "tablet-portrait") {
                this.overviewDisplayLayout = buildOverviewPortraitLayout(this.page.widgets, CONTROL_TABLET_COLS);
                return;
            }
            if (this.overviewLayoutMode === "mobile") {
                this.overviewDisplayLayout = buildOverviewMobileLayout(this.page.widgets, CONTROL_MOBILE_COLS);
                return;
            }

            this.overviewDisplayLayout = null;
        },
        onChangeEnergyEfficiencyView(view) {
            if (view === "chart") {
                this.getEnergyEfficiencyData("YEAR");
            } else if (view === "pyramid") {
                this.getEnergyEfficiencyData("MONTH");
            } else if (view === "card") {
                this.getEnergyEfficiencyData("MONTH");
            }
        },
        async getEnergyEfficiencyData(timeDsvn) {
            const energyWidget = this.$refs.xeWidgets.filter((v) => v.widget.type === "xeEnergyEfficiency");

            if (!energyWidget) return;

            let time;
            if (timeDsvn === "MONTH") {
                time = this.getCurrentYearMonth();
            } else if (timeDsvn === "YEAR") {
                time = this.getCurrentYear();
            } else {
                return;
            }

            try {
                const result = await backEndApi.buildingEfficiency.analyzeEnergyAndCarbon(time);
                if (result.status === 200) {
                    energyWidget.forEach((v) => {
                        v.applyData(result.data);
                    });
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getGoalUsageChartData() {
            const goalWidgets = this.$refs.xeWidgets.filter((v) => v.widget.type === "xeGoalUsageChart");
            if (!goalWidgets.length) return;

            // timeDsvn에 따른 파라미터 매핑
            const timeDsvnParams = {
                DAYBYMONTH: {
                    timeDsvn: "DAYBYMONTH",
                    fromDate: this.getCurrentDateByTimeDsvn("month"),
                    toDate: this.getCurrentDateByTimeDsvn("month"),
                },
                MONTHBYYEAR: {
                    timeDsvn: "MONTHBYYEAR",
                    fromDate: this.getCurrentDateByTimeDsvn("year"),
                    toDate: this.getCurrentDateByTimeDsvn("year"),
                },
                ANALYSIS: {
                    timeDsvn: "MONTHBYYEAR",
                    fromDate: this.getCurrentDateByTimeDsvn("year"),
                    toDate: this.getCurrentDateByTimeDsvn("year"),
                },
            };

            // 각 위젯에 대해 병렬로 데이터 처리
            const promises = goalWidgets.map(async (goalWidget) => {
                try {
                    const result = await backEndApi.analysisModel.getAnalysisModel(goalWidget.widget.goalModelIdx);

                    if (result.status !== 200) {
                        console.warn(`Failed to get analysis model for widget: ${goalWidget.widget.goalModelIdx}`);
                        return;
                    }

                    // 위젯의 viewMode에 따른 파라미터 설정
                    const viewMode = goalWidget.widget.timeDsvn || "DAYBYMONTH";
                    const dateParams = timeDsvnParams[viewMode] || timeDsvnParams.DAYBYMONTH;

                    // 결과 데이터와 날짜 파라미터 병합
                    const requestData = { ...result.data, ...dateParams };

                    const analyzeResult = await backEndApi.analysisModel.analyzeGoal(requestData);
                    goalWidget.newApplyData(analyzeResult.data);
                } catch (error) {
                    console.error(`Error processing goal widget ${goalWidget.widget.goalModelIdx}:`, error);
                }
            });

            // 모든 위젯 처리를 병렬로 실행
            await Promise.all(promises);
        },
        increment() {
            return ++this.cardIndex;
        },
        // onPageResized(){
        //   this.initScreenSize()
        // },
        // initScreenSize(){
        //   const { width } = this.$refs.screen.getBoundingClientRect();

        //   this.screenWidth = width;

        //   let x = 10 * (this.boxRate / 100);

        //   this.page.cellSize.w = x;
        //   this.page.cellSize.h = x;
        // },
        // 초기화
        initSetting() {
            this.setCardWidgetIndex();

            // 조회조건 초기화
            if (this.isEmpty(this.page.search)) {
                this.page.search = {
                    isCompare: false,
                    timeType: 4,
                    isLoadSearch: false,
                    display: true,
                };
            }

            if (this.isEmpty(this.page.search.isCompare)) this.page.search.isCompare = false; // 비교모드 사용여부
            if (this.isEmpty(this.page.search.timeType)) this.page.search.timeType = 4; // 시간 유형
            if (this.isEmpty(this.page.search.isLoadSearch)) this.page.search.isLoadSearch = true; // 화면로드시 조회
            if (this.isEmpty(this.page.search.display)) this.page.search.display = false; // 조회박스 표시여부

            this.page.search.timeType = parseInt(this.page.search.timeType);

            // dndgrid 설정값 초기화
            if (!this.page.cellSize) this.page.cellSize = { w: 10, h: 10, margin: 0 };

            // 윗젯들 초기화
            if (this.page.widgets) {
                this.page.widgets.forEach(this.initWidget);
            } else {
                this.page.widgets = [];
            }

            // isLoadSearch 화면로드시 조회는 SearchBox에서 호출됨.
            // 위젯이 준비가 되었으므로 화면에 표시한다.
            this.isShow = true;

            // 서치박스 없다면 주기적 화면 갱신 동작
            if (!this.page.search.display) {
                this.onRefreshObj = setInterval(() => {
                    this.onRefresh();
                }, this.refreshTerm);
            } else {
                if (this.onRefreshObj != null) {
                    clearInterval(this.onRefreshObj);
                    this.onRefreshObj = null;
                }
            }
        },
        applyWidgetSizeConstraints(widget) {
            switch (widget.type) {
                    case "xeProgressCard": {
                        widget.minW = 2;
                        widget.minH = 4;
                        widget.maxW = 24;
                        widget.maxH = 7;
                        break;
                    }
                    case "xeEnergyEfficiency": {
                        widget.minW = 6;
                        widget.minH = 5;
                        widget.maxW = 12;
                        widget.maxH = 11;
                        break;
                    }
                    case "xeIndoorAirQuality": {
                        widget.minW = 3;
                        widget.minH = 3;
                        widget.maxW = 12;
                        widget.maxH = 6;
                        break;
                    }
                    case "xeDiscomfortIndex": {
                        widget.minW = 3;
                        widget.minH = 3;
                        widget.maxW = 12;
                        widget.maxH = 6;
                        break;
                    }
                    case "xeCompareCard":
                    case "xeSelfRateCard":
                    case "xeCostCard": {
                        widget.minW = 3;
                        widget.minH = 4;
                        widget.maxW = 24;
                        widget.maxH = 7;
                        break;
                        // widget.minW = 3; widget.minH = 7; widget.maxW = 12; widget.maxH = 15; break;
                    }
                    case "xeGoalUsageChart": {
                        widget.minW = 7;
                        widget.minH = 7;
                        widget.maxW = 24;
                        widget.maxH = 20;
                        break;
                    }

                    case "xeDataCard": {
                        break;
                    }

                    case "xeDoughnut": {
                        widget.minW = 2;
                        widget.minH = 2;
                        widget.maxW = 24;
                        widget.maxH = 500;
                        break;
                    }
                    case "xePeekCard": {
                        widget.minW = 3;
                        widget.minH = 3;
                        widget.maxW = 24;
                        widget.maxH = 500;
                        break;
                    }

                    case "xeHorizontalBar":
                    case "xeGridTable":
                    case "xePie":
                    case "xeLine":
                    case "xeArea":
                    case "xeUsageChart":
                    case "xeBar":
                    case "xeCompareChart":
                    case "xeBizInfo": {
                        widget.minW = 5;
                        widget.minH = 4;
                        widget.maxW = 24;
                        widget.maxH = 500;
                        break;
                    }
                    case "xeHistoryRange": {
                        widget.minW = 6;
                        widget.minH = 5;
                        widget.maxW = 24;
                        widget.maxH = 20;
                        break;
                    }
                    case "xeSelfRate":
                    case "xeSelfRateNew": {
                        widget.minW = 7;
                        widget.minH = 8;
                        widget.maxW = 25;
                        widget.maxH = 31;
                        break;
                    }
                    case "xeFemsOverview": {
                        widget.minW = 6;
                        widget.minH = 10;
                        widget.maxW = 25;
                        widget.maxH = 31;
                        break;
                    }

                    case "xeCarbonSaving": {
                        widget.minW = 7;
                        widget.minH = 9;
                        widget.maxW = 21;
                        widget.maxH = 27;
                        break;
                    }
                    case "xeSelfRateToc": {
                        widget.minW = 8;
                        widget.minH = 16;
                        widget.maxW = 24;
                        widget.maxH = 48;
                        break;
                    }
                    case "xeIndoorEnvInfo": {
                        widget.minW = 6;
                        widget.minH = 5;
                        widget.maxW = 21;
                        widget.maxH = 27;
                        break;
                    }
                    case "xeForecast": {
                        widget.minW = 6;
                        widget.minH = 5;
                        widget.maxW = 21;
                        widget.maxH = 27;
                        break;
                    }
                    case "xeEquipmentControl": {
                        widget.minW = 3;
                        widget.minH = 3;
                        widget.maxW = 21;
                        widget.maxH = 27;
                        break;
                    }
                    case "xeEquipStatusMonitor": {
                        widget.minW = 6;
                        widget.minH = 5;
                        widget.maxW = 24;
                        widget.maxH = 30;
                        break;
                    }
                    case "xeBlankWidget": {
                        widget.minW = 1;
                        widget.minH = 1;
                        widget.maxW = 21;
                        widget.maxH = 27;
                        break;
                    }
                    case "xeSplitLine": {
                        widget.minW = 1;
                        widget.minH = 1;
                        widget.maxW = 24;
                        widget.maxH = 3;
                        break;
                    }
                    default: {
                        widget.minW = 2;
                        widget.minH = 1;
                        widget.maxW = 24;
                        widget.maxH = 500;
                    }
                }
        },
        initWidget(widget) {
            // dndgird에 위젯의 기본값을 설정한다.
            if (!widget.id) {
                // id가 없으면, 중복되지 않는 id를 생성한다.
                let i = 99;
                let j = this.page.widgets.length;
                widget.id = `W${(i + 1).pad(3)}-${(j + 1).pad(3)}-${Math.random().toString(36).substring(3)}`; // 임의 문자열 생성 추가
                widget.i = widget.id;
            }

            widget.hidden = false;
            widget.pinned = !this.isEditMode;

            if (!widget.position) {
                this.applyWidgetSizeConstraints(widget);
                widget.w = widget.minW;
                widget.h = widget.minH;

                const pos = this.getAppendBottomPosition(widget.w, widget.h);
                widget.x = pos.x;
                widget.y = pos.y;
                this.syncWidgetPosition(widget);
            }

            switch (widget.type) {
                case "xeProgressCard": {
                    widget.index = this.cardIndex++;
                    break;
                }
                case "xeCompareCard":
                case "xeSelfRateCard":
                case "xeCostCard": {
                    widget.index = this.cardIndex++;
                    break;
                    // widget.minW = 3; widget.minH = 7; widget.maxW = 12; widget.maxH = 15; break;
                }
                case "xeDataCard": {
                    widget.index = this.cardIndex++;
                    break;
                }
            }

            return widget;
        },
        setCardWidgetIndex() {
            this.page.widgets.forEach((widget, index) => {
                switch (widget.type) {
                    // case "xeDataCard":
                    case "xeProgressCard":
                    case "xeCompareCard":
                    case "xeSelfRateCard":
                    case "xeCostCard": {
                        this.card.push({
                            arrIndex: index,
                            x: widget.x,
                            y: widget.y,
                        });
                        break;
                    }
                }
            });
            this.cardSort();
        },
        cardSort() {
            var ySort = this.card;

            var originIdx = [];
            var sortData = [];

            ySort.forEach((element) => {
                originIdx.push(element.arrIndex);
            });

            //this.card y축 정렬
            for (var k = 0; k < this.card.length; k++) {
                for (var l = 0; l < this.card.length; l++) {
                    if (this.card[k].y == this.card[l].y) {
                        continue;
                    }

                    if (this.card[k].y < this.card[l].y) {
                        var tempY = ySort[l];
                        ySort[l] = ySort[k];
                        ySort[k] = tempY;
                    }
                }
            }

            var xSort = ySort;
            for (var i = 0; i < ySort.length; i++) {
                for (var j = 0; j < ySort.length; j++) {
                    if (ySort[i].y == ySort[j].y) {
                        if (ySort[i].x == ySort[j].x) {
                            continue;
                        }

                        if (ySort[i].x < ySort[j].x) {
                            var tempX = xSort[j];
                            xSort[j] = xSort[i];
                            xSort[i] = tempX;
                        }
                    }
                }
            }

            xSort.forEach((element) => {
                sortData.push(this.page.widgets[element.arrIndex]);
            });

            for (var r = 0; r < this.card.length; r++) {
                this.page.widgets[originIdx[r]] = sortData[r];
            }
        },
        getMaxLayoutBottom() {
            let maxBottom = 0;
            (this.page.widgets || []).forEach((widget) => {
                maxBottom = Math.max(maxBottom, (widget.y || 0) + (widget.h || 1));
            });
            return maxBottom;
        },
        getAppendBottomPosition() {
            if (!this.page.widgets.length) {
                return { x: 0, y: 0 };
            }

            return { x: 0, y: this.getMaxLayoutBottom() };
        },
        widgetsOverlap(a, b) {
            const ax = a.x || 0;
            const ay = a.y || 0;
            const aw = a.w || 1;
            const ah = a.h || 1;
            const bx = b.x || 0;
            const by = b.y || 0;
            const bw = b.w || 1;
            const bh = b.h || 1;
            return ax < bx + bw && ax + aw > bx && ay < by + bh && ay + ah > by;
        },
        captureLayoutPositions() {
            return (this.page.widgets || []).map((widget) => ({
                i: widget.i,
                x: widget.x || 0,
                y: widget.y || 0,
                w: widget.w || 1,
                h: widget.h || 1,
            }));
        },
        restoreUnaffectedWidgetsAfterDrag(draggedId) {
            const snapshot = this._dragRestoreSnapshot;
            if (!snapshot) return;

            const dragged = this.page.widgets.find((widget) => widget.i === draggedId);
            if (!dragged) {
                this._dragRestoreSnapshot = null;
                return;
            }

            let changed = false;

            snapshot.forEach((orig) => {
                if (orig.i === draggedId) return;

                const widget = this.page.widgets.find((item) => item.i === orig.i);
                if (!widget) return;

                if (this.widgetsOverlap(dragged, orig)) {
                    return;
                }

                if (widget.x !== orig.x || widget.y !== orig.y) {
                    widget.x = orig.x;
                    widget.y = orig.y;
                    this.syncWidgetPosition(widget);
                    changed = true;
                }
            });

            this._dragRestoreSnapshot = null;

            if (changed) {
                this.$nextTick(() => {
                    this.$refs.editGridLayout?.layoutUpdate?.();
                });
            }
        },
        onWidgetDragMoved(widgetId) {
            if (!this.isEditMode || this._layoutUndoInProgress) return;
            this.restoreUnaffectedWidgetsAfterDrag(widgetId);
        },
        syncWidgetPosition(widget) {
            widget.position = {
                x: widget.x,
                y: widget.y,
                w: widget.w,
                h: widget.h,
            };
        },
        saveLayoutSnapshot() {
            if (this._layoutUndoInProgress) return;

            const snapshot = JSON.parse(JSON.stringify(this.page.widgets || []));
            const serialized = JSON.stringify(snapshot);
            const last = this.layoutUndoStack[this.layoutUndoStack.length - 1];

            if (last && JSON.stringify(last) === serialized) return;

            this.layoutUndoStack.push(snapshot);
            if (this.layoutUndoStack.length > 30) {
                this.layoutUndoStack.shift();
            }
        },
        undoLayoutChange() {
            if (!this.layoutUndoStack.length) return;

            const snapshot = this.layoutUndoStack.pop();
            this._layoutUndoInProgress = true;
            this.page.widgets = JSON.parse(JSON.stringify(snapshot));
            this._layoutDragSnapshotSaved = false;

            this.$nextTick(() => {
                this.$refs.editGridLayout?.layoutUpdate?.();
                this.refreshControlDisplayLayout();
                this.refreshOverviewDisplayLayout();
                this._layoutUndoInProgress = false;
            });

            if (this.$toast?.info) {
                this.$toast.info(this.$t("레이아웃 변경을 실행 취소했습니다."));
            }
        },
        bindLayoutUndoKeydown() {
            if (this._layoutUndoKeydownBound) return;
            this._layoutUndoKeydownBound = (event) => {
                if (!this.isEditMode || !this.canUndoLayout) return;
                if (!(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== "z" || event.shiftKey) return;

                const tag = event.target?.tagName?.toLowerCase();
                if (tag === "input" || tag === "textarea" || event.target?.isContentEditable) return;

                event.preventDefault();
                this.undoLayoutChange();
            };
            document.addEventListener("keydown", this._layoutUndoKeydownBound);
        },
        unbindLayoutUndoKeydown() {
            if (!this._layoutUndoKeydownBound) return;
            document.removeEventListener("keydown", this._layoutUndoKeydownBound);
            this._layoutUndoKeydownBound = null;
        },
        bindGridDragSnapshot() {
            const grid = this.$refs.editGridLayout?.$el;
            if (!grid || this._gridDragSnapshotHandler) return;

            this._gridDragSnapshotHandler = (event) => {
                if (!this.isEditMode || this._layoutUndoInProgress) return;

                const item = event.target?.closest?.(".vue-grid-item");
                if (!item || !grid.contains(item)) return;
                if (event.target.closest("button, input, textarea, select, a, .modal, .vue-context")) return;

                if (!this._layoutDragSnapshotSaved) {
                    this.saveLayoutSnapshot();
                    this._layoutDragSnapshotSaved = true;
                }

                this._dragRestoreSnapshot = this.captureLayoutPositions();
            };

            this._gridDragEndHandler = () => {
                this._layoutDragSnapshotSaved = false;
            };

            grid.addEventListener("mousedown", this._gridDragSnapshotHandler, true);
            document.addEventListener("mouseup", this._gridDragEndHandler);
        },
        unbindGridDragSnapshot() {
            const grid = this.$refs.editGridLayout?.$el;
            if (grid && this._gridDragSnapshotHandler) {
                grid.removeEventListener("mousedown", this._gridDragSnapshotHandler, true);
            }
            if (this._gridDragEndHandler) {
                document.removeEventListener("mouseup", this._gridDragEndHandler);
            }
            this._gridDragSnapshotHandler = null;
            this._gridDragEndHandler = null;
            this._layoutDragSnapshotSaved = false;
            this._dragRestoreSnapshot = null;
        },
        getNextPosition(newWidget) {
            const sizeProbe = { type: newWidget.type };
            this.applyWidgetSizeConstraints(sizeProbe);
            const w = sizeProbe.minW || 2;
            const h = sizeProbe.minH || 1;
            const pos = this.getAppendBottomPosition(w, h);
            return { x: pos.x, y: pos.y, w, h: newWidget.defaultHeigth || h };
        },
        createWidgetFromTransfer(transfer) {
            const newWidget = this.merge({}, transfer.item, {
                panel: { display: transfer.item.panel.display },
            });

            delete newWidget.icon;
            delete newWidget.color;
            delete newWidget.effect;
            delete newWidget.defaultHeigth;

            return newWidget;
        },
        addWidgetFromTransfer(transfer) {
            const newWidget = this.createWidgetFromTransfer(transfer);

            this.saveLayoutSnapshot();
            this.initWidget(newWidget);
            this.page.widgets.push(newWidget);
            this.highlightAndScrollToWidget(newWidget);

            if (this.$toast?.info) {
                this.$toast.info(this.$t("위젯이 추가되었습니다. Ctrl+Z로 실행 취소할 수 있습니다."));
            }
        },
        onLayoutDrop(transfer) {
            try {
                this.addWidgetFromTransfer(transfer);
            } catch (err) {
                console.log("onLayoutDrop err", err.message);
            }
        },
        highlightAndScrollToWidget(widget) {
            this.$set(widget, "_justAdded", true);

            this.$nextTick(() => {
                const gridEl = this.$refs.editGridLayout?.$el;
                if (gridEl) {
                    const margin = this.gridMargin;
                    const rowHeight = this.gridRowHeight;
                    const topPx = margin[1] + (widget.y || 0) * (rowHeight + margin[1]);
                    const gridTop = gridEl.getBoundingClientRect().top + window.scrollY;
                    const targetY = gridTop + topPx - 120;

                    window.scrollTo({
                        top: Math.max(0, targetY),
                        behavior: "smooth",
                    });
                }

                setTimeout(() => {
                    this.$set(widget, "_justAdded", false);
                }, 2500);
            });
        },
        // ctx 메뉴
        openContextMenu(evt, widget) {
            this.$refs.ctxMenu.open(evt, widget);
        },
        onSettingWidget(widget) {
            this.contextMenu.widget = widget;
            // baseWidget에서 isShowSetting을 watch하고 있다가 팝업을 표시해 줌..
            this.contextMenu.isShowSetting = !this.contextMenu.isShowSetting;
        },
        onDeleteWidget(curWidget) {
            const idx = this.page.widgets.findIndex((w) => w.i === curWidget.i || w === curWidget);
            if (idx === -1) return;

            this.saveLayoutSnapshot();
            this.page.widgets.splice(idx, 1);

            this.$nextTick(() => {
                const grid = this.$refs.editGridLayout;
                if (grid && typeof grid.layoutUpdate === "function") {
                    grid.layoutUpdate();
                }
            });

            this.refreshControlDisplayLayout();
            this.refreshOverviewDisplayLayout();
        },
        // search box
        onRefresh() {
            // 부모페이지에서 재조회시 호출..
            this.onSearch();
        },
        getPoints() {
            let periodPoints = [];
            let comparePoints = [];

            if (this.page.widgets) {
                this.page.widgets.forEach((widget) => {
                    // series 구조에 따른 타입분류

                    if (
                        widget.type == "xeChartLine" ||
                        widget.type == "xeChartPie" ||
                        widget.type == "xeChartGauge" ||
                        widget.type == "xeChartRadar" ||
                        widget.type == "xeLine" ||
                        widget.type == "xeArea" ||
                        widget.type == "xeBar" ||
                        widget.type == "xeCompareChart" ||
                        widget.type == "xeGoalUsageChart" ||
                        widget.type == "xeHistoryRange"
                    ) {
                        periodPoints = periodPoints.concat(
                            widget.chart.series.filter((v) => !v.compare || v.compare == false).map((v) => v.point),
                        );
                        comparePoints = comparePoints.concat(
                            widget.chart.series.filter((v) => v.compare).map((v) => v.point),
                        );
                    } else if (
                        widget.type == "xeEnergyCard" ||
                        widget.type == "xeGoalCard" ||
                        widget.type == "xeSimpleCard"
                    ) {
                        let obj = widget.objects;
                        if (obj) {
                            obj.main && obj.main.point ? periodPoints.push(obj.main.point) : null;
                            obj.bottom && obj.bottom.point ? periodPoints.push(obj.bottom.point) : null;
                            obj.goal && obj.goal.point ? periodPoints.push(obj.goal.point) : null;
                        }
                    } else if (widget.type == "xeChartScatter" || widget.type == "xeChartHorizontalBar") {
                        periodPoints = periodPoints.concat(
                            widget.chart.series.filter((v) => !v.compare || v.compare == false).map((v) => v.point),
                        );
                        comparePoints = comparePoints.concat(
                            widget.chart.series.filter((v) => v.compare).map((v) => v.point),
                        );
                        periodPoints = periodPoints.concat(
                            widget.addition.xAxes.point ? [widget.addition.xAxes.point] : [],
                        );
                    } else if (widget.type == "xeGridTable" || widget.type == "xePivotTable") {
                        periodPoints = periodPoints.concat(widget.columns.map((v) => v.point));
                        periodPoints = periodPoints.concat(
                            widget.columns.filter((v) => !v.compare || v.compare == false).map((v) => v.point),
                        );
                        comparePoints = comparePoints.concat(
                            widget.columns.filter((v) => v.compare).map((v) => v.point),
                        );
                    } else if (widget.type == "xeChartDonut" || widget.type == "xeRankCard") {
                        periodPoints = periodPoints.concat(widget.chart.series.map((v) => v.point));
                        periodPoints = periodPoints.concat(widget.chart.series.map((v) => v.maxPt));
                        comparePoints = comparePoints.concat(widget.chart.series.map((v) => v.point));
                        comparePoints = comparePoints.concat(widget.chart.series.map((v) => v.maxPt));
                    }
                });
            }

            return {
                periodPoints: periodPoints.filter((v) => v != "DATE_AND_TIME").unique(),
                comparePoints: comparePoints.filter((v) => v != "DATE_AND_TIME").unique(),
            };
        },
        appendUsePoint(useAddr) {
            if (this.errorPoints.filter((v) => v == useAddr).length == 0 && this.isEmpty(this.liveAM[useAddr])) {
                this.errorPoints.push(useAddr);
            }
        },

        onSearch() {
            // 화면 전환시 오류 발생하여 코드 추가 - TypeError: Cannot read property 'conditions' of undefined
            if (this.isEmpty(this.$refs.searchBox) || !this.$refs.searchBox.hasOwnProperty("conditions")) return;

            this.searchBoxCond = this.$refs.searchBox.conditions;

            // Date Nomalize 처리
            this.searchBoxCond.period.sDt = this.searchBoxCond.period.sDt.normalize(this.searchBoxCond.type);
            this.searchBoxCond.period.eDt = this.searchBoxCond.period.eDt.normalize(this.searchBoxCond.type);

            if (this.searchBoxCond.isCompare) {
                this.searchBoxCond.compare.sDt = this.searchBoxCond.compare.sDt.normalize(this.searchBoxCond.type);
                this.searchBoxCond.compare.eDt = this.searchBoxCond.compare.eDt.normalize(this.searchBoxCond.type);
            }
            // 위젯별 조건 모으기

            // 기본 baseline    this.searchBoxCond.period,
            // 비교 compare     this.searchBoxCond.compare,
            // Self기본 : now, baseline.sDt, compare.sDt,  "2020-01-01"
            // Self비교 : now, baseline.sDt, compare.sDt

            try {
                // 조회중인지 체크
                this.isSearchable = false;
                this.searchCnt = 0;

                // 조회가 없는 위젯은 조회 카운트에서 제거한다.
                let searchLength = this.$refs.xeWidgets.filter(
                    (v) => !this.isEmpty(v.getWidgetConds(this.searchBoxCond)),
                ).length;

                // 위젯별 조회로 변경
                this.$refs.xeWidgets.forEach((widget) => {
                    let searchCond = widget.getWidgetConds(this.searchBoxCond);

                    // 관제점이 존재하지 않은면 경고메세지를 출력한다.
                    searchCond.map((v) => v.points.map((useAddr) => this.appendUsePoint(useAddr)));

                    if (this.cancelObj[widget._uid]) {
                        this.cancelObj[widget._uid].cancel("Operation canceled by the user.");
                    } else {
                        this.cancelObj[widget._uid] = this.cancelToken.source();
                    }

                    // TODO
                    // 신규 추가 위젯 API 우회 추가
                    // widget.widget.type의 타입이 신규 위젯이랑 같을 시 기존 api말고 새로운 api 호출로 변경 필요

                    if (widget.widget.type === "xeGoalUsageChart") {
                        this.getGoalUsageChartData();
                    } else if (widget.widget.type === "xePeekCard") {
                        /*
                  backEndApi.widget.widgetPeakData(widget.widget.zoneIdx).then((result) => {
                    widget.applyData(result.data);
                  });

                  전력피크 위젯 호출 API 변경 2023.02.14 권철규
                */
                        backEndApi.widget.widgetPowerLoad(widget.widget.ptaddr).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeUsageChart") {
                        //TODO - 현재 index 값을 고정, 추후 변경 필요
                        backEndApi.widget.widgetConsumptData(widget.widget.zoneIdx).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeSelfRate" || widget.widget.type === "xeSelfRateNew") {
                        //TODO - 현재 index 값을 고정, 추후 변경 필요

                        backEndApi.widget.selfRenceRate(widget.widget.zoneIdx).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeCarbonSaving") {
                        // TODO - 탄소절감량 api 작성
                    } else if (widget.widget.type === "xeSelfRateToc") {
                        //TODO - 현재 index 값을 고정, 추후 변경 필요

                        backEndApi.widget.selfRateByRegion().then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeSelfRateCard") {
                        //TODO - 현재 index 값을 고정, 추후 변경 필요

                        backEndApi.widget.selfRenceRateMonth(widget.widget.zoneIdx).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeFemsOverview") {
                        const sysNodeIdx = widget.widget.sysNodeIdx || null;
                        backEndApi.widget.getFemsOverview(sysNodeIdx).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeIndoorEnvInfo") {
                        // backEndApi.widget.irEvmnStatusInfo(widget.widget.equipIdx, widget.widget.equipTypeCode).then((result) => {
                        // 	widget.applyData(result.data);
                        // });
                        const searchParams = {
                            sysNodeIdx: widget.widget.sysNodeIdx,
                            queryType: widget.widget.queryType,
                        };
                        backEndApi.sysNode.getGroupOprtStatus(searchParams).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeForecast") {
                        backEndApi.widget.getWeatherCast().then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeDiscomfortIndex") {
                        const regDt = this.getCurrentYearMonth();

                        backEndApi.buildingEfficiency.analyzeOperatingEnvironment(regDt).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeIndoorAirQuality") {
                        const regDt = this.getCurrentYearMonth();

                        backEndApi.buildingEfficiency.analyzeOperatingEnvironment(regDt).then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeEnergyEfficiency") {
                        this.getEnergyEfficiencyData(this.efficiencyGradeTimeDsvn || "MONTH");

                        // let time = this.getCurrentYearMonth();

                        // backEndApi.buildingEfficiency.analyzeEnergyAndCarbon(time).then((result) => {
                        //     widget.applyData(result.data);
                        // });
                    } else if (widget.widget.type === "xeBizInfo") {
                        //사업장 정보 일기예보 Data
                        backEndApi.widget.getCurrentWeather().then((result) => {
                            widget.applyData(result.data);
                        });
                    } else if (widget.widget.type === "xeEquipmentControl") {
                        widget.applyData();
                    } else if (widget.widget.type === "xeEquipStatusMonitor") {
                        widget.applyData();
                    } else if (widget.widget.type === "xeCostCard") {
                        // 현재 날짜의 년월을 "YYYYMM" 형식으로 변환
                        const now = new Date();
                        const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}`;
                        // contractIdx가 없으면 null로 전달 (전체 계약 조회)
                        const contractIdx = widget.widget.contractIdx || null;

                        backEndApi.energyBillCalc
                            .getMonthlyCost(contractIdx, dateStr, 1)
                            .then((result) => {
                                if (result && result.data) {
                                    widget.applyData(result.data);
                                }
                            })
                            .catch((error) => {
                                console.error("xeCostCard: 월별 비용 조회 실패:", error);
                            });
                    } else {
                        // searchCond가 비어있거나 유효하지 않으면 API 호출하지 않음
                        if (this.isEmpty(searchCond) || searchCond.length === 0) {
                            console.warn(`Widget ${widget.widget.type} has empty search conditions`);
                            if (searchLength == this.searchCnt) {
                                this.isSearchable = true;
                            }
                            return;
                        }

                        // 각 조건의 points가 비어있지 않은지 확인
                        const hasValidPoints = searchCond.some((cond) => cond.points && cond.points.length > 0);
                        if (!hasValidPoints) {
                            console.warn(`Widget ${widget.widget.type} has no valid points in search conditions`);
                            if (searchLength == this.searchCnt) {
                                this.isSearchable = true;
                            }
                            return;
                        }

                        backEndApi.summary
                            .searchDataWithToken(searchCond, null, this.cancelObj[widget._uid])
                            .then(({ data }) => {
                                if (this.$err(data)) return;
                                if (this.isEmpty(data)) return;

                                // 해당 위젯에 직접 바인딩
                                widget.applyData(data);

                                // 조회된 데이터 카운트
                                this.searchCnt++;

                                if (searchLength == this.searchCnt) {
                                    this.isSearchable = true;
                                }
                            })
                            .catch((err) => {
                                if (axios.isCancel(err)) {
                                    console.info("Axios Exception: ", err.message);
                                } else {
                                    this.isSearchable = true;
                                    console.error("onSearch err", err);
                                }
                            })
                            .finally(() => {
                                this.cancelObj[widget._uid] = null;
                            });
                    }
                });
            } catch (err) {
                console.warn("onSearch err", err.message);
            }
        },
        getCurrentYear() {
            const now = new Date();
            return now.getFullYear();
        },
        getCurrentYearMonth() {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, "0");
            return `${year}${month}`;
        },
        onChangeWidget(curWidget) {
            // 설정모달에서 OK를 누르면 위젯정보가 변경된 것이므로, 해당위젯을 찾아서 실제정보를 저장한다.
            let idx = this.page.widgets.findIndex((v) => v.i === curWidget.i);
            Vue.set(this.page.widgets, idx, curWidget);
        },
        // layout
        handleTitleDrop(transfer, self) {
            // 위젯 변경 (설정값은 카피 못함 기존 설정 초기화됨)
            let newWidget = transfer.item;

            newWidget.i = self.i;
            newWidget = self;

            this.page.widgets.forEach((widget, idx) => {
                if (widget.i == self.i) this.page.widgets[idx] = newWidget;
            });

            this.isShow = false;
            Vue.nextTick(() => {
                this.isShow = true;
            });
        },
        getCurrentDateByTimeDsvn(timeDsvn) {
            const now = new Date();
            const year = now.getFullYear();
            if (timeDsvn === "month") {
                const month = String(now.getMonth() + 1).padStart(2, "0");
                return `${year}-${month}`;
            }
            if (timeDsvn === "year") {
                return `${year}`;
            }
            return "";
        },
        onDownloadCsv() {
            // TODO: 전체 위젯 for문 돌면서 후처리된 데이터를 수집하여 다운로드 시켜야야 함.. 현재 불가능

            function csvExport(exportData) {
                if (!exportData || !exportData.data) return;

                let arrData = exportData.data;
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    Object.keys(arrData[0]).join(","),
                    ...arrData.map((item) => Object.values(item).join(",")),
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                //console.log("csvContent ----------------------- ", arrData, Object.keys(arrData[0]).join(","));

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", `${exportData.title}.csv`);
                link.click();
            }

            let csv = {
                title: this.page.title ? this.page.title : "export",
                data: null,
            };

            let doubleRows = [];

            this.$refs.xeWidgets.forEach((widget) => {
                // let searchCond = widget.getWidgetConds(this.searchBoxCond);

                if (widget.widgetLogs.length == 0) return;

                let widgetRows = widget.widgetLogs.map((log, i) => {
                    let dateTimeName = "Baseline";
                    if (i == 1) dateTimeName = "Comparison";

                    return log.dates.map((dateTime, j) => {
                        if (dateTime.length > 1) dateTime = `${dateTime[1] || ""} ${dateTime[0] || ""}`;

                        //Points
                        let row = {};
                        row[dateTimeName] = dateTime;
                        Object.keys(log.points).map((point) => {
                            row[i == 1 ? point + "_C" : point] = log.points[point][j];
                        });
                        return row;
                    });
                });

                doubleRows.range(widgetRows);
            });

            if (doubleRows.length < 1) {
                this.alertNoti(popupMessages.COMMON_NO_DATA_POPUP_MESSAGE);
                return;
            }
            // BaseLine 조회일 경우
            if (doubleRows.length <= 1) {
                csv.data = doubleRows[0] ? doubleRows[0] : [];

                csvExport(csv);
                return;
            }

            // 두개의 배열길이 다른경우, 더 긴 배열에 길이만큼 for문이 돌아서 row가 생성되어야 함.
            let baseRows = doubleRows[0];
            let compareRows = doubleRows[1];

            if (baseRows.length > compareRows.length) {
                csv.data = baseRows.map((row, idx) => {
                    let base = baseRows[idx];
                    let compare = compareRows[idx];
                    return Object.assign(base, compare);
                });
            } else {
                csv.data = compareRows.map((row, idx) => {
                    let base = baseRows[idx];
                    let compare = compareRows[idx];

                    return Object.assign(compare, base);
                });
            }

            csvExport(csv);
        },
    },
});
</script>
